/**
 * Wishlist Injector - SAFE WISHLIST ATTRIBUTION + PREMIUM TOAST EVENTS (V17)
 *
 * ✅ Varyant değişiminde kalbin eski varyantta dolu görünmesini engeller
 * ✅ Kalp butonuna işlem kilidi ekler, çift tık ihtiyacını azaltır
 * ✅ Optimistic UI + güvenli rollback mantığı kullanır
 * ✅ Normal sepete eklemelerde _wl / _wl_sid basmaz
 * ✅ Sadece wishlist'te aktif olan varyant PDP'den sepete eklenirse _wl_source=product_page_wishlisted basar
 * ✅ Wishlist sayfasındaki sepete eklemelerde _wl_source=wishlist_page korunur
 * ✅ Debug logları temizlenmiştir
 */

(function () {
  if (window.__LS_WISHLIST_INJECTOR_V17_UX__) return;

  window.__LS_WISHLIST_INJECTOR_V17_UX__ = true;
  window.__LS_WISHLIST_INJECTOR_V17_SINGLE_TOAST__ = true;
  window.__LS_WISHLIST_INJECTOR_V16__ = true;
  window.__LS_WISHLIST_INJECTOR_V15__ = true;
  window.__LS_WISHLIST_INJECTOR_V14__ = true;
  window.__LS_WISHLIST_INJECTOR_V13__ = true;

  const CONFIG = {
    debug: false,
    productSelectors: {
      form: 'form[action*="/cart/add"]',
      atc: '[name="add"]',
      variantIdInput: '[name="id"]'
    },
    svgPath:
      'M1.00818 5.72501C1.02725 5.41736 0.982499 5.08205 1.00818 4.778C1.2976 1.37778 5.41412 -0.386486 7.8282 2.3255C8.08388 2.61266 8.23061 2.92281 8.44813 3.20961C8.46611 3.23369 8.47564 3.26675 8.51636 3.25705C8.55231 3.24842 8.85091 2.73305 8.91694 2.645C11.1736 -0.374626 15.5128 1.05684 15.9626 4.62418C16.2912 7.23123 14.3969 9.07635 12.6006 10.6753C11.4568 11.6935 10.1359 12.8618 8.92574 13.7876C8.69354 13.9652 8.53947 14.0913 8.24051 13.9156C7.22917 13.0405 6.17675 12.2092 5.16431 11.3355C3.73149 10.0985 1.83097 8.4927 1.23451 6.66554C1.13363 6.3561 1.08668 6.03912 1.00818 5.72501Z',
    localStorageKey: 'wishlist',
    sidKey: 'wl_sid',
    header: {
      bubbleId: 'wishlist-bubble',
      countId: 'wishlist-bubble-count'
    }
  };

  let _localCache = [];
  let _variantChangingUntil = 0;

  const _recentConversionPings = new Map();
  const _pendingWishlistKeys = new Set();
  const _busyButtons = new WeakSet();

  const dlog = (...args) => {
    if (CONFIG.debug) console.log(...args);
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function getOrCreateSid() {
    let sid = localStorage.getItem(CONFIG.sidKey);

    if (!sid) {
      sid = 'sid_' + Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem(CONFIG.sidKey, sid);
    }

    return sid;
  }

  function waitForWishlistAPI(timeout = 2500) {
    if (window.WishlistAPI) {
      return Promise.resolve(window.WishlistAPI);
    }

    return new Promise((resolve) => {
      const startedAt = Date.now();

      const timer = setInterval(() => {
        if (window.WishlistAPI) {
          clearInterval(timer);
          resolve(window.WishlistAPI);
          return;
        }

        if (Date.now() - startedAt > timeout) {
          clearInterval(timer);
          resolve(null);
        }
      }, 80);
    });
  }

  function injectStyles() {
    if (document.getElementById('wishlist-fixed-css')) return;

    const style = document.createElement('style');
    style.id = 'wishlist-fixed-css';

    style.innerHTML = `
      .wishlist-bubble.hidden {
        display: none !important;
      }

      .wishlist-pdp-wrapper {
        display: flex;
        gap: 4px;
        width: 100%;
        align-items: stretch;
      }

      .wishlist-pdp-btn {
        flex: 0 0 3.5rem !important;
        width: 3.5rem !important;
        min-width: 3.5rem !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform .18s ease, opacity .18s ease;
      }

      .wishlist-pdp-btn:hover {
        transform: scale(1.05);
        opacity: .9;
      }

      .wishlist-pdp-btn svg {
        width: 20px;
        height: 20px;
      }

      .wishlist-pdp-btn.active svg {
        fill: currentColor;
      }

      .wishlist-pdp-btn.is-loading {
        pointer-events: none;
        opacity: .72;
      }

      .wishlist-pdp-btn.is-variant-settling {
        opacity: .72;
      }

      .wishlist-pdp-btn.is-variant-settling path {
        fill: none !important;
      }

      .ls-wishlist-toast-v2 {
        position: fixed;
        left: 18px;
        bottom: 18px;
        z-index: 999999;
        width: min(360px, calc(100vw - 36px));
        display: grid;
        grid-template-columns: 54px minmax(0, 1fr) auto;
        align-items: center;
        gap: 12px;
        padding: 12px 44px 12px 12px;
        background: rgba(255,255,255,.96);
        border: 1px solid rgba(0,0,0,.12);
        color: #0b0b0b;
        box-shadow: 0 18px 56px rgba(0,0,0,.16);
        backdrop-filter: blur(14px);
        -webkit-backdrop-filter: blur(14px);
        opacity: 1;
        transform: translateY(0);
        transition: opacity .24s ease, transform .24s ease;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      }

      .ls-wishlist-toast-v2.is-out { opacity: 0; transform: translateY(10px); }
      .ls-wishlist-toast-v2__image { width: 54px; height: 54px; background: #f3f3f3; overflow: hidden; display: flex; align-items: center; justify-content: center; font-size: 22px; }
      .ls-wishlist-toast-v2__image img { width: 100%; height: 100%; object-fit: cover; display: block; }
      .ls-wishlist-toast-v2__title { display: block; font-size: 13px; line-height: 1.15; font-weight: 760; letter-spacing: -.25px; }
      .ls-wishlist-toast-v2__text { display: block; margin-top: 4px; font-size: 12px; line-height: 1.35; color: rgba(0,0,0,.58); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      .ls-wishlist-toast-v2__cta { min-height: 34px; align-self: center; padding: 0 13px; background: #111; color: #fff; display: inline-flex; align-items: center; justify-content: center; text-decoration: none; font-size: 11.5px; font-weight: 760; white-space: nowrap; }
      .ls-wishlist-toast-v2__close { position: absolute; right: 8px; top: 8px; width: 26px; height: 26px; border: 0; border-radius: 999px; background: transparent; color: #111; cursor: pointer; font-size: 18px; opacity: .56; }

      @media (max-width: 749px) {
        .ls-wishlist-toast-v2 { left: 12px; right: 12px; bottom: 12px; width: auto; grid-template-columns: 50px minmax(0,1fr); padding-right: 42px; }
        .ls-wishlist-toast-v2__cta { grid-column: 1 / -1; width: 100%; margin-top: 2px; }
      }
    `;

    document.head.appendChild(style);
  }

  function readLocalWishlist() {
    try {
      return JSON.parse(localStorage.getItem(CONFIG.localStorageKey) || '[]');
    } catch {
      return [];
    }
  }

  async function refreshCache() {
    if (window.WishlistAPI) {
      try {
        const data = await window.WishlistAPI.get();

        const isGuest =
          !window.__SHOPIFY_CUSTOMER_ID__ ||
          window.__SHOPIFY_CUSTOMER_ID__ === 'null' ||
          window.__SHOPIFY_CUSTOMER_ID__ === null;

        if ((!data || data.length === 0) && isGuest) {
          const v = readLocalWishlist();
          _localCache = v.map((i) => (typeof i === 'string' ? i : i.storageKey));
        } else {
          _localCache = data || [];
        }
      } catch {
        const v = readLocalWishlist();
        _localCache = v.map((i) => (typeof i === 'string' ? i : i.storageKey));
      }
    } else {
      const v = readLocalWishlist();
      _localCache = v.map((i) => (typeof i === 'string' ? i : i.storageKey));
    }

    updateUI();
  }

  function makeKey(handle, variantId) {
    return variantId ? `${handle}::${variantId}` : handle;
  }

  function getHandleFromUrl() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const last = parts[parts.length - 1] || '';

    return last.split('?')[0];
  }

  function getVariantFromUrl() {
    try {
      const url = new URL(window.location.href);
      const q = url.searchParams.get('variant');

      if (q) return String(q).trim();
    } catch {}

    return null;
  }

  function getVariantFromForm(form) {
    const input =
      form?.querySelector?.(CONFIG.productSelectors.variantIdInput) ||
      document.querySelector(`${CONFIG.productSelectors.form} ${CONFIG.productSelectors.variantIdInput}`) ||
      document.querySelector(CONFIG.productSelectors.variantIdInput);

    const inputValue = input?.value ? String(input.value).trim() : '';

    return inputValue || null;
  }

  function getSelectedVariantId(form) {
    const fromUrl = getVariantFromUrl();

    if (fromUrl) return fromUrl;

    const fromForm = getVariantFromForm(form);

    if (fromForm) return fromForm;

    return null;
  }

  function getStableSelectedVariantId(form) {
    const fromUrl = getVariantFromUrl();
    const fromForm = getVariantFromForm(form);

    if (fromUrl && fromForm && String(fromUrl) !== String(fromForm)) {
      return null;
    }

    return fromUrl || fromForm || null;
  }

  function getConversionKeyForVariantId(variantId) {
    if (!variantId) return null;

    const handle = getHandleFromUrl();
    if (!handle) return null;

    return makeKey(handle, String(variantId).trim());
  }

  function getWishlistAttributionForVariantId(variantId) {
    if (!variantId) {
      return {
        shouldStamp: false,
        key: null,
        handle: null,
        variantId: null,
        source: null
      };
    }

    const handle = getHandleFromUrl();

    if (!handle) {
      return {
        shouldStamp: false,
        key: null,
        handle: null,
        variantId: String(variantId),
        source: null
      };
    }

    const cleanVariantId = String(variantId).trim();
    const key = makeKey(handle, cleanVariantId);
    const shouldStamp = isKeyActive(key);

    return {
      shouldStamp,
      key,
      handle,
      variantId: cleanVariantId,
      source: shouldStamp ? 'product_page_wishlisted' : null
    };
  }

  function removeWishlistFormProperties(form) {
    if (!form) return;

    [
      'properties[_wl]',
      'properties[_wl_source]',
      'properties[_wl_sid]',
      'properties[_wl_handle]',
      'properties[_wl_variant]'
    ].forEach((name) => {
      form.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
        input.remove();
      });
    });
  }

  function upsertHiddenInput(form, name, value) {
    if (!form || !name) return;

    let input = form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function stampWishlistFormProperties(form, attribution) {
    if (!form || !attribution || !attribution.shouldStamp) return;

    const sid = getOrCreateSid();

    upsertHiddenInput(form, 'properties[_wl]', '1');
    upsertHiddenInput(form, 'properties[_wl_source]', attribution.source || 'product_page_wishlisted');
    upsertHiddenInput(form, 'properties[_wl_sid]', sid);
    upsertHiddenInput(form, 'properties[_wl_handle]', attribution.handle || '');
    upsertHiddenInput(form, 'properties[_wl_variant]', attribution.variantId || '');
  }

  function buildWishlistPropertiesForVariant(variantId) {
    const attribution = getWishlistAttributionForVariantId(variantId);

    if (!attribution.shouldStamp) {
      return null;
    }

    const sid = getOrCreateSid();

    return {
      _wl: '1',
      _wl_source: attribution.source || 'product_page_wishlisted',
      _wl_sid: sid,
      _wl_handle: attribution.handle || '',
      _wl_variant: attribution.variantId || ''
    };
  }

  function cleanWishlistPropertiesObject(properties) {
    const next = {
      ...(properties || {})
    };

    delete next._wl;
    delete next._wl_source;
    delete next._wl_sid;
    delete next._wl_handle;
    delete next._wl_variant;

    return next;
  }

  function getCombinedCacheList() {
    const set = new Set(_localCache || []);

    _pendingWishlistKeys.forEach((key) => {
      if (key) set.add(key);
    });

    return Array.from(set);
  }

  function isKeyActive(key) {
    if (!key) return false;

    return getCombinedCacheList().includes(key);
  }

  function setButtonVisual(btn, active) {
    const path = btn.querySelector('path');

    if (!path) return;

    if (active) {
      path.setAttribute('fill', 'currentColor');
      btn.classList.add('active');
    } else {
      path.setAttribute('fill', 'none');
      btn.classList.remove('active');
    }
  }

  function neutralizeWishlistButtons() {
    document.querySelectorAll('.wishlist-pdp-btn').forEach((btn) => {
      btn.classList.add('is-variant-settling');
      setButtonVisual(btn, false);
    });
  }

  function markVariantChanging() {
    _variantChangingUntil = Date.now() + 220;

    neutralizeWishlistButtons();

    setTimeout(updateUI, 120);
    setTimeout(updateUI, 260);
    setTimeout(updateUI, 520);
    setTimeout(updateUI, 850);
  }

  async function queueWishlistConversionPing(variantId, source = 'product_page_wishlisted') {
    const key = getConversionKeyForVariantId(variantId);

    if (!key) return;

    if (!isKeyActive(key)) {
      return;
    }

    const now = Date.now();
    const dedupeKey = `${key}::${source}`;
    const lastPingAt = _recentConversionPings.get(dedupeKey);

    if (lastPingAt && now - lastPingAt < 3500) {
      return;
    }

    _recentConversionPings.set(dedupeKey, now);

    const api = await waitForWishlistAPI(2500);

    if (!api || typeof api.pingConversion !== 'function') {
      return;
    }

    try {
      await api.pingConversion(key, source);
    } catch (e) {
      console.warn('Wishlist conversion ping error:', e);
    }
  }

  function updateUI() {
    const list = getCombinedCacheList();
    const count = list.length;
    const isVariantSettling = Date.now() < _variantChangingUntil;

    const bubble = document.getElementById(CONFIG.header.bubbleId);
    const countEl = document.getElementById(CONFIG.header.countId);

    if (countEl) {
      countEl.textContent = String(count);
    }

    if (bubble) {
      bubble.classList.toggle('hidden', count === 0);
      bubble.style.removeProperty('display');
      bubble.removeAttribute('hidden');
    }

    document.querySelectorAll('.wishlist-pdp-btn').forEach((btn) => {
      const handle = btn.dataset.handle;
      const form =
        document.getElementById(btn.dataset.formId) ||
        document.querySelector(CONFIG.productSelectors.form);

      if (isVariantSettling) {
        btn.classList.add('is-variant-settling');
        setButtonVisual(btn, false);
        return;
      }

      btn.classList.remove('is-variant-settling');

      const variantId = getStableSelectedVariantId(form) || getSelectedVariantId(form);
      const key = makeKey(handle, variantId);
      const active = variantId ? list.includes(key) : list.includes(handle);

      setButtonVisual(btn, active);
    });
  }

  function bindCartObserver() {
    if (window.__wl_cart_observer_bound) return;
    window.__wl_cart_observer_bound = true;

    let observer = null;
    let scheduled = false;

    const kick = () => {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateUI();
        setTimeout(updateUI, 60);
      });
    };

    const tryAttach = () => {
      const cartEl =
        document.querySelector('cart-icon[data-testid="cart-icon"]') ||
        document.querySelector('cart-icon.header-actions__cart-icon') ||
        document.querySelector('[data-testid="cart-icon"]');

      if (!cartEl || observer) return;

      observer = new MutationObserver(kick);

      observer.observe(cartEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    };

    tryAttach();

    let t = 0;

    const iv = setInterval(() => {
      tryAttach();

      if (++t > 20) {
        clearInterval(iv);
      }
    }, 250);
  }

  function bindVariantChangeRepaint() {
    if (window.__wl_variant_change_bound) return;
    window.__wl_variant_change_bound = true;

    const repaintAggressive = () => {
      markVariantChanging();
    };

    document.addEventListener('change', repaintAggressive, true);
    document.addEventListener('input', repaintAggressive, true);

    document.addEventListener(
      'click',
      (e) => {
        if (
          e.target.closest('fieldset') ||
          e.target.closest('select') ||
          e.target.closest('[class*="variant"]') ||
          e.target.closest('[data-option-value]') ||
          e.target.closest('[data-variant-id]')
        ) {
          repaintAggressive();
        }
      },
      true
    );

    const originalPush = history.pushState;

    history.pushState = function () {
      originalPush.apply(this, arguments);
      repaintAggressive();
    };

    const originalReplace = history.replaceState;

    history.replaceState = function () {
      originalReplace.apply(this, arguments);
      repaintAggressive();
    };

    window.addEventListener('popstate', repaintAggressive);
  }

  function getProductMeta() {
    let price = 0;
    let title = document.title || 'Unknown Product';
    let image = '';

    const https = (u) => {
      if (!u || typeof u !== 'string') return '';

      u = u.trim();

      if (u.startsWith('//')) return 'https:' + u;
      if (u.startsWith('http://')) return u.replace('http://', 'https://');

      return u;
    };

    const optimizeShopifyImage = (url, width = 240) => {
      if (!url) return '';

      try {
        const cleanUrl = url.replace(/(&|\?)width=\d+/, '');
        const separator = cleanUrl.includes('?') ? '&' : '?';

        return `${cleanUrl}${separator}width=${width}`;
      } catch {
        return url;
      }
    };

    const getDomMainImage = () => {
      const selectors = [
        'media-gallery img[aria-current="true"]',
        'media-gallery .is-active img',
        '.product__media img[aria-current="true"]',
        '.product__media .is-active img',
        '[data-media-id].is-active img',
        '[data-media-id][aria-hidden="false"] img',
        '.product__media img',
        '.product-media img',
        '.product__gallery img',
        '.product-gallery img',
        'img[data-product-featured-image]',
        'img[fetchpriority="high"]'
      ];

      const candidates = [];

      selectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((img) => {
          if (!(img instanceof HTMLImageElement)) return;

          const rect = img.getBoundingClientRect();

          if (rect.width > 50 && rect.height > 50) {
            const src = img.currentSrc || img.src;

            if (src) {
              candidates.push({
                src,
                area: rect.width * rect.height
              });
            }
          }
        });
      });

      if (!candidates.length) return '';

      candidates.sort((a, b) => b.area - a.area);

      return https(candidates[0].src) || '';
    };

    let variantImage = '';

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      const p = window.ShopifyAnalytics.meta.product;
      const currentVid = getSelectedVariantId(document);
      const currentVariant = p.variants
        ? p.variants.find((v) => String(v.id) === String(currentVid))
        : null;

      if (currentVariant) {
        price = currentVariant.price ? currentVariant.price / 100 : price;
        title = currentVariant.name || title;

        variantImage =
          https(currentVariant.featured_image?.src) ||
          https(currentVariant.featured_image) ||
          https(currentVariant.image?.src) ||
          https(currentVariant.image) ||
          '';
      } else {
        price = p.price ? p.price / 100 : price;
      }
    } else {
      const priceMeta = document.querySelector('meta[property="og:price:amount"]');

      if (priceMeta) {
        price = parseFloat(priceMeta.content);
      }

      const titleMeta = document.querySelector('meta[property="og:title"]');

      if (titleMeta) {
        title = titleMeta.content;
      }
    }

    const domImage = getDomMainImage();

    image = domImage || variantImage;

    if (!image) {
      const imgMeta = document.querySelector('meta[property="og:image"]');

      if (imgMeta) {
        image = https(imgMeta.content) || '';
      }
    }

    return {
      price,
      title,
      image: optimizeShopifyImage(image, 240)
    };
  }

  function normalizeCartAttributes(attributes) {
    if (!attributes) return {};

    if (Array.isArray(attributes)) {
      return attributes.reduce((acc, attr) => {
        if (attr && attr.name) {
          acc[attr.name] = attr.value || '';
        }

        return acc;
      }, {});
    }

    if (typeof attributes === 'object') {
      return { ...attributes };
    }

    return {};
  }

  async function ensureCartHasSessionId() {
    const sid = getOrCreateSid();

    if (!sid) return;

    try {
      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      const cart = await cartRes.json();

      const attributes = normalizeCartAttributes(cart.attributes || cart.note_attributes);

      if (attributes['Wishlist-Session-ID'] === sid) {
        return;
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          note: cart.note || '',
          attributes: {
            ...attributes,
            'Wishlist-Session-ID': sid
          }
        })
      });
    } catch (e) {
      console.warn('Cart stamping error:', e);
    }
  }

  function watchCartChanges() {
    if (window.__wl_cart_watcher_bound) return;
    window.__wl_cart_watcher_bound = true;

    const events = ['cart:add', 'cart:update', 'cart:refresh', 'cart-drawer:open'];

    events.forEach((eventName) => {
      document.addEventListener(eventName, () => {
        setTimeout(ensureCartHasSessionId, 100);

        if (window.location.pathname.includes('/products/')) {
          const form = document.querySelector(CONFIG.productSelectors.form);
          const variantId = getSelectedVariantId(form);
          const attribution = getWishlistAttributionForVariantId(variantId);

          if (variantId && attribution.shouldStamp) {
            setTimeout(() => queueWishlistConversionPing(variantId, attribution.source), 150);
          }
        }
      });
    });

    const cartIcon =
      document.querySelector('cart-icon') ||
      document.querySelector('[data-testid="cart-icon"]');

    if (cartIcon) {
      const observer = new MutationObserver(() => {
        ensureCartHasSessionId();
      });

      observer.observe(cartIcon, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }

  function interceptFormSubmits() {
    if (window.__wl_form_intercept_bound) return;
    window.__wl_form_intercept_bound = true;

    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target.closest('form[action*="/cart/add"]');

        if (!form) return;

        const variantId = getSelectedVariantId(form);
        const attribution = getWishlistAttributionForVariantId(variantId);

        removeWishlistFormProperties(form);

        if (!attribution.shouldStamp) {
          return;
        }

        stampWishlistFormProperties(form, attribution);

        setTimeout(ensureCartHasSessionId, 200);

        if (variantId) {
          setTimeout(() => queueWishlistConversionPing(variantId, attribution.source), 250);
          setTimeout(() => queueWishlistConversionPing(variantId, attribution.source), 800);
        }
      },
      true
    );
  }

  function hasExistingWishlistPageProperties(properties) {
    if (!properties || typeof properties !== 'object') return false;

    return (
      String(properties._wl || '') === '1' &&
      String(properties._wl_source || '') === 'wishlist_page' &&
      !!properties._wl_sid &&
      !!properties._wl_variant
    );
  }

  function addWishlistAttributionToJsonBody(body) {
    if (!body || typeof body !== 'object') {
      return {
        body,
        conversionVariantIds: [],
        conversionSources: [],
        stamped: false
      };
    }

    const conversionVariantIds = [];
    const conversionSources = [];
    let stamped = false;

    if (Array.isArray(body.items)) {
      body.items = body.items.map((item) => {
        const variantId = item && item.id ? String(item.id) : null;

        if (hasExistingWishlistPageProperties(item.properties)) {
          if (variantId) {
            conversionVariantIds.push(String(variantId));
            conversionSources.push('wishlist_page');
          }

          stamped = true;

          return item;
        }

        const wishlistProperties = buildWishlistPropertiesForVariant(variantId);

        if (!wishlistProperties) {
          return {
            ...item,
            properties: cleanWishlistPropertiesObject(item.properties)
          };
        }

        conversionVariantIds.push(String(variantId));
        conversionSources.push(wishlistProperties._wl_source || 'product_page_wishlisted');
        stamped = true;

        return {
          ...item,
          properties: {
            ...(item.properties || {}),
            ...wishlistProperties
          }
        };
      });

      return {
        body,
        conversionVariantIds,
        conversionSources,
        stamped
      };
    }

    if (body.id) {
      const variantId = String(body.id);

      if (hasExistingWishlistPageProperties(body.properties)) {
        conversionVariantIds.push(variantId);
        conversionSources.push('wishlist_page');

        return {
          body,
          conversionVariantIds,
          conversionSources,
          stamped: true
        };
      }

      const wishlistProperties = buildWishlistPropertiesForVariant(variantId);

      if (!wishlistProperties) {
        body.properties = cleanWishlistPropertiesObject(body.properties);

        return {
          body,
          conversionVariantIds,
          conversionSources,
          stamped: false
        };
      }

      conversionVariantIds.push(variantId);
      conversionSources.push(wishlistProperties._wl_source || 'product_page_wishlisted');
      stamped = true;

      body.properties = {
        ...(body.properties || {}),
        ...wishlistProperties
      };
    }

    return {
      body,
      conversionVariantIds,
      conversionSources,
      stamped
    };
  }

  function hasExistingWishlistPageFormData(body) {
    if (!body || typeof body.get !== 'function') return false;

    return (
      String(body.get('properties[_wl]') || '') === '1' &&
      String(body.get('properties[_wl_source]') || '') === 'wishlist_page' &&
      !!body.get('properties[_wl_sid]') &&
      !!body.get('properties[_wl_variant]')
    );
  }

  function getWishlistPageVariantFromFormBody(body) {
    if (!body || typeof body.get !== 'function') return null;

    return (
      body.get('properties[_wl_variant]') ||
      body.get('id') ||
      null
    );
  }

  function removeWishlistPropertiesFromFormBody(body) {
    if (!body || typeof body.delete !== 'function') return;

    [
      'properties[_wl]',
      'properties[_wl_source]',
      'properties[_wl_sid]',
      'properties[_wl_handle]',
      'properties[_wl_variant]'
    ].forEach((name) => {
      body.delete(name);
    });
  }

  function stampWishlistPropertiesToFormBody(body, attribution) {
    if (!body || !attribution || !attribution.shouldStamp) return;

    const sid = getOrCreateSid();

    if (typeof body.append === 'function' && body instanceof FormData) {
      body.append('properties[_wl]', '1');
      body.append('properties[_wl_source]', attribution.source || 'product_page_wishlisted');
      body.append('properties[_wl_sid]', sid);
      body.append('properties[_wl_handle]', attribution.handle || '');
      body.append('properties[_wl_variant]', attribution.variantId || '');
      return;
    }

    if (typeof body.set === 'function') {
      body.set('properties[_wl]', '1');
      body.set('properties[_wl_source]', attribution.source || 'product_page_wishlisted');
      body.set('properties[_wl_sid]', sid);
      body.set('properties[_wl_handle]', attribution.handle || '');
      body.set('properties[_wl_variant]', attribution.variantId || '');
    }
  }

  function interceptFetchAddToCart() {
    if (window.__wl_fetch_intercept_bound) return;
    window.__wl_fetch_intercept_bound = true;

    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const [url, options] = args;

      const urlString =
        typeof url === 'string'
          ? url
          : url && url.url
            ? String(url.url)
            : String(url || '');

      const isCartAdd = urlString.includes('/cart/add');

      if (!isCartAdd) {
        return originalFetch.apply(this, args);
      }

      const conversionVariantIds = [];
      const conversionSources = [];
      let stampedAnyWishlistItem = false;

      try {
        if (options && options.body instanceof FormData) {
          const existingWishlistPage = hasExistingWishlistPageFormData(options.body);

          if (existingWishlistPage) {
            const existingVariantId = getWishlistPageVariantFromFormBody(options.body);

            if (existingVariantId) {
              conversionVariantIds.push(String(existingVariantId));
              conversionSources.push('wishlist_page');
            }

            stampedAnyWishlistItem = true;
          } else {
            const formVariantId = options.body.get('id');
            const attribution = getWishlistAttributionForVariantId(formVariantId);

            removeWishlistPropertiesFromFormBody(options.body);

            if (attribution.shouldStamp) {
              stampWishlistPropertiesToFormBody(options.body, attribution);

              conversionVariantIds.push(String(formVariantId));
              conversionSources.push(attribution.source || 'product_page_wishlisted');
              stampedAnyWishlistItem = true;
            }
          }
        } else if (options && options.body instanceof URLSearchParams) {
          const existingWishlistPage = hasExistingWishlistPageFormData(options.body);

          if (existingWishlistPage) {
            const existingVariantId = getWishlistPageVariantFromFormBody(options.body);

            if (existingVariantId) {
              conversionVariantIds.push(String(existingVariantId));
              conversionSources.push('wishlist_page');
            }

            stampedAnyWishlistItem = true;
          } else {
            const formVariantId = options.body.get('id');
            const attribution = getWishlistAttributionForVariantId(formVariantId);

            removeWishlistPropertiesFromFormBody(options.body);

            if (attribution.shouldStamp) {
              stampWishlistPropertiesToFormBody(options.body, attribution);

              conversionVariantIds.push(String(formVariantId));
              conversionSources.push(attribution.source || 'product_page_wishlisted');
              stampedAnyWishlistItem = true;
            }
          }
        } else if (options && typeof options.body === 'string') {
          const rawBody = options.body.trim();

          if (rawBody.startsWith('{') || rawBody.startsWith('[')) {
            const body = JSON.parse(options.body);
            const result = addWishlistAttributionToJsonBody(body);

            result.conversionVariantIds.forEach((variantId, index) => {
              conversionVariantIds.push(String(variantId));
              conversionSources.push(result.conversionSources?.[index] || 'product_page_wishlisted');
            });

            stampedAnyWishlistItem = Boolean(result.stamped);
            options.body = JSON.stringify(result.body);
          } else {
            const params = new URLSearchParams(options.body);
            const existingWishlistPage = hasExistingWishlistPageFormData(params);

            if (existingWishlistPage) {
              const existingVariantId = getWishlistPageVariantFromFormBody(params);

              if (existingVariantId) {
                conversionVariantIds.push(String(existingVariantId));
                conversionSources.push('wishlist_page');
              }

              stampedAnyWishlistItem = true;
            } else {
              const formVariantId = params.get('id');
              const attribution = getWishlistAttributionForVariantId(formVariantId);

              removeWishlistPropertiesFromFormBody(params);

              if (attribution.shouldStamp) {
                stampWishlistPropertiesToFormBody(params, attribution);

                conversionVariantIds.push(String(formVariantId));
                conversionSources.push(attribution.source || 'product_page_wishlisted');
                stampedAnyWishlistItem = true;
              }

              options.body = params.toString();
            }
          }
        }
      } catch (e) {
        console.warn('Wishlist cart/add body patch error:', e);
      }

      const promise = originalFetch.apply(this, args);

      promise
        .then((res) => {
          if (res && res.ok) {
            conversionVariantIds.forEach((variantId, index) => {
              const source = conversionSources[index] || 'product_page_wishlisted';

              setTimeout(() => queueWishlistConversionPing(variantId, source), 100);
              setTimeout(() => queueWishlistConversionPing(variantId, source), 700);
            });

            if (stampedAnyWishlistItem) {
              setTimeout(ensureCartHasSessionId, 200);
            }
          }
        })
        .catch(() => {});

      return promise;
    };
  }

  function bindMainAtcListener() {
    if (window.__wl_main_atc_bound) return;
    window.__wl_main_atc_bound = true;

    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target.closest('form[action*="/cart/add"]');

        if (!form) return;

        const variantId = getSelectedVariantId(form);
        const attribution = getWishlistAttributionForVariantId(variantId);

        if (variantId && attribution.shouldStamp) {
          setTimeout(() => queueWishlistConversionPing(variantId, attribution.source), 250);
          setTimeout(() => queueWishlistConversionPing(variantId, attribution.source), 800);
        }
      },
      true
    );
  }

  function injectProduct() {
    if (document.querySelector('.wishlist-pdp-btn')) {
      updateUI();
      return;
    }

    const atc = document.querySelector(CONFIG.productSelectors.atc);

    if (!atc) return;

    const form =
      atc.closest('form') ||
      document.querySelector(CONFIG.productSelectors.form);

    if (!form) return;

    if (!form.id) {
      form.id = 'wl-form-' + Math.random().toString(36).slice(2, 9);
    }

    const atcParent = atc.parentNode;

    if (!atcParent || !atcParent.classList) return;

    if (!atcParent.classList.contains('wishlist-pdp-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'wishlist-pdp-wrapper';

      atcParent.insertBefore(wrapper, atc);
      wrapper.appendChild(atc);

      atc.style.cssText =
        'flex: 1 1 auto !important; width: 100% !important; margin: 0 !important;';

      const handle = getHandleFromUrl();

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wishlist-pdp-btn button button--secondary';
      btn.dataset.handle = handle;
      btn.dataset.formId = form.id;
      btn.setAttribute('aria-label', 'Wishlist');

      btn.innerHTML = `<svg viewBox="0 0 17 15" fill="none" stroke="currentColor" stroke-width="1.3"><path d="${CONFIG.svgPath}"></path></svg>`;

      btn.onclick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (_busyButtons.has(btn)) {
          return;
        }

        _busyButtons.add(btn);
        btn.classList.add('is-loading');
        btn.disabled = true;

        try {
          if (Date.now() < _variantChangingUntil) {
            await sleep(240);
          }

          const currentForm = document.getElementById(btn.dataset.formId) || form;
          const variantId = getStableSelectedVariantId(currentForm) || getSelectedVariantId(currentForm);

          if (!variantId) {
            showToast('Varyant bulunamadı');
            return;
          }

          const key = makeKey(handle, variantId);
          const isActive = isKeyActive(key);

          btn.style.transform = 'scale(0.85)';

          setTimeout(() => {
            btn.style.transform = 'scale(1)';
          }, 150);

          if (isActive) {
            _localCache = _localCache.filter((k) => k !== key);
            _pendingWishlistKeys.delete(key);

            setButtonVisual(btn, false);
            updateUI();

            const api = await waitForWishlistAPI(2500);

            if (api && typeof api.remove === 'function') {
              const result = await api.remove(key);

              if (result?.errors) {
                _localCache.push(key);
                setButtonVisual(btn, true);
                showToast('Bir hata oluştu');
              } else {
                showToast({ title: 'Wishlistten çıkarıldı', text: 'Ürün favorilerinden kaldırıldı.' });
                emitWishlistUX('remove', { handle, variantId, storageKey: key });
              }
            } else {
              showToast({ title: 'Wishlistten çıkarıldı', text: 'Ürün favorilerinden kaldırıldı.' });
                emitWishlistUX('remove', { handle, variantId, storageKey: key });
            }
          } else {
            _pendingWishlistKeys.add(key);

            if (!_localCache.includes(key)) {
              _localCache = _localCache.filter((x) => x !== handle);
              _localCache.push(key);
            }

            setButtonVisual(btn, true);
            updateUI();

            const meta = getProductMeta();
            const api = await waitForWishlistAPI(2500);

            if (api && typeof api.add === 'function') {
              const result = await api.add({
                handle,
                variantId,
                storageKey: key,
                price: meta.price,
                title: meta.title,
                image: meta.image
              });

              if (result?.errors) {
                _pendingWishlistKeys.delete(key);
                _localCache = _localCache.filter((k) => k !== key);
                setButtonVisual(btn, false);
                showToast('Bir hata oluştu');
              } else {
                showToast({ title: 'Item saved', text: (meta.title || 'Ürün') + ' favorilerine eklendi.', image: meta.image, ctaUrl: '/pages/wishlist', ctaLabel: 'Wishlist’i gör' });
                emitWishlistUX('add', { handle, variantId, storageKey: key, title: meta.title, image: meta.image, price: meta.price });
              }
            } else {
              showToast({ title: 'Item saved', text: (meta.title || 'Ürün') + ' favorilerine eklendi.', image: meta.image, ctaUrl: '/pages/wishlist', ctaLabel: 'Wishlist’i gör' });
              emitWishlistUX('add', { handle, variantId, storageKey: key, title: meta.title, image: meta.image, price: meta.price });
            }

            _pendingWishlistKeys.delete(key);
          }

          await refreshCache();
          updateUI();
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          _busyButtons.delete(btn);
        }
      };

      wrapper.appendChild(btn);

      setTimeout(updateUI, 0);
    }
  }


  function emitWishlistUX(action, detail) {
    try {
      window.dispatchEvent(new CustomEvent('lsw:wishlist:' + action, {
        detail: Object.assign({ action, sessionId: getOrCreateSid(), occurredAt: Date.now() }, detail || {})
      }));
    } catch {}
  }


  function escapeWishlistToastHTML(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));
  }

  function showToast(msg) {
    const data = typeof msg === 'object' && msg ? msg : { title: String(msg || '') };
    const t = document.createElement('div');
    const title = data.title || 'Item saved';
    const text = data.text || '';
    const image = data.image || '';
    const ctaUrl = data.ctaUrl || data.url || '';
    const ctaLabel = data.ctaLabel || data.cta || 'Wishlist';

    t.className = 'ls-wishlist-toast-v2';
    t.innerHTML = `
      <button type="button" class="ls-wishlist-toast-v2__close" aria-label="Kapat">×</button>
      <div class="ls-wishlist-toast-v2__image">${image ? `<img src="${escapeWishlistToastHTML(image)}" alt="">` : '♡'}</div>
      <div class="ls-wishlist-toast-v2__copy">
        <strong class="ls-wishlist-toast-v2__title">${escapeWishlistToastHTML(title)}</strong>
        <span class="ls-wishlist-toast-v2__text">${escapeWishlistToastHTML(text)}</span>
      </div>
      ${ctaUrl ? `<a class="ls-wishlist-toast-v2__cta" href="${escapeWishlistToastHTML(ctaUrl)}">${escapeWishlistToastHTML(ctaLabel)}</a>` : ''}
    `;

    document.querySelectorAll('.ls-wishlist-toast-v2').forEach((el) => el.remove());
    document.body.appendChild(t);

    const close = t.querySelector('.ls-wishlist-toast-v2__close');
    if (close) close.addEventListener('click', () => t.remove());

    setTimeout(() => {
      t.classList.add('is-out');
      setTimeout(() => t.remove(), 260);
    }, data.duration || 4200);
  }

  async function init() {
    injectStyles();
    bindCartObserver();
    bindVariantChangeRepaint();

    interceptFormSubmits();
    interceptFetchAddToCart();
    bindMainAtcListener();
    watchCartChanges();

    if (window.location.pathname.includes('/products/')) {
      injectProduct();
    }

    const api = await waitForWishlistAPI(2500);

    if (api && typeof api.init === 'function') {
      await api.init();
    }

    await refreshCache();

    setTimeout(ensureCartHasSessionId, 1000);

    if (window.location.pathname.includes('/products/')) {
      injectProduct();
      updateUI();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  let attempts = 0;

  const interval = setInterval(() => {
    if (_localCache.length === 0) {
      refreshCache();
    }

    updateUI();

    if (++attempts > 10) {
      clearInterval(interval);
    }
  }, 500);

  window.addEventListener('storage', (e) => {
    if (e.key === CONFIG.localStorageKey) {
      refreshCache();
    }
  });
})();